export default __webpack_public_path__ + "static/media/intro4.8a8dab70.mp3";